export default __webpack_public_path__ + "8c1d3af300b1addd425aad3175bb1110.png";